module.exports = __webpack_public_path__ + "img/Zeltbauen.ea267d23.jpg";